var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import { ControlLabel } from 'react-bootstrap';
import PropTypes from 'prop-types';
import React from 'react';
import ReactSlider from 'bodyspec-react-slider';

import './Slider.css';

function Slider(props, _ref) {
  var form = _ref.form;
  var label = props.label,
      max = props.max,
      min = props.min,
      name = props.name;


  var markers = [];
  for (var i = min; i <= max; i++) {
    markers.push({ label: i, value: i });
  }

  return React.createElement(
    'div',
    null,
    React.createElement(
      ControlLabel,
      null,
      label
    ),
    React.createElement(ReactSlider, _extends({
      markerLabel: markers,
      ticks: true
    }, props, {
      value: form.get(name) || min,
      onChange: function onChange(v) {
        return form.set(name, v);
      }
    }))
  );
}

Slider.contextTypes = {
  form: PropTypes.object.isRequired
};

Slider.propTypes = process.env.NODE_ENV !== "production" ? {
  label: PropTypes.string,
  max: PropTypes.number.isRequired,
  min: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired
} : {};

export default Slider;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bodyspec-form-builder/es/Fields/Slider.js
// module id = 718
// module chunks = 0